import React from 'react';
import { Create } from 'react-admin';
import PositionRateSettingsForm from '../shared/position-rate-settings-form/PositionRateSettingsForm';
import { getTransform } from '../rateSettingsTransform';

const LocationPositionRateSettingCreate = () => (
  <Create
    transform={getTransform(
      ['location_id', 'incremental_margin_percent_1099', 'incremental_margin_percent_w2'],
      'settings',
    )}
  >
    <PositionRateSettingsForm settingsField="settings" />
  </Create>
);

export default LocationPositionRateSettingCreate;
